<template>
    <div class="about">
        <div v-if="student.about" class='content' v-html="student.about" />

        <div v-else class='content' v-html="$t('students.profile.noDescription')" />

        <button type="button" v-if="currentAccountIsSameAs(student)"
                @click="toggle"
                class="button is-primary">
            {{$t('global.actions.edit')}}
        </button>

        <modal-card v-if="edit" :header="$t('students.profile.editAbout')" @close="toggle">
            <template slot="content">
                <vue-editor :editorToolbar="$options.toolbarOptions" id="about" name="about"
                            v-model="about" :data-vv-as="$t('students.profile.about')"
                            v-validate="'required|min_stripped_length:300|max_stripped_length:1200'"/>

                <p v-if="veeErrors.has('about')" class="help is-danger">{{veeErrors.first('about')}}</p>
                <p v-else-if="containsUrl" class="help is-danger">{{$t('students.profile.noUrlsAllowed')}}</p>
            </template>

            <template slot="footer">
                <div class="is-pulled-right">
                    <button class="button" @click="toggle">
                        {{$t('global.actions.cancel')}}
                    </button>

                    <button class="button is-primary"  @click="save" :disabled="veeErrors.any() || containsUrl">
                        {{$t('global.actions.saveChanges')}}
                    </button>
                </div>

            </template>
        </modal-card>
    </div>
</template>

<script>
    import ModalCard from '@/global/components/ModalCard'; // TODO: replace with buefy.
    import AccountMixin from '@/global/mixins/AccountMixin';
    import { VueEditor } from 'vue2-editor';
    import StudentService from '@/taskflex/students/services/StudentService';

    export default {
        data() {
            return {
                containsUrl: false,
                edit: false,
                about: null,
            };
        },

        mixins: [AccountMixin],

        toolbarOptions: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'], // remove formatting & link button
        ],

        props: {
            student: {
                type: Object,
            },
        },

        watch: {
            about() {
                // TODO: move this to util or mixin when used elsewhere, to keep DRY
                this.containsUrl = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g.test(this.about)
                    || /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g.test(this.about);
            },
        },

        methods: {
            save() {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    const { student } = this;

                    const options = {
                        about: this.about,
                    };

                    StudentService.update(student.id, options, () => {
                        this.$eventHub.$emit('students.profile.update');

                        this.toggle();
                    });
                });
            },

            toggle() {
                const { about } = this.student;
                this.about = about;

                this.edit = !this.edit;
            },
        },

        components: {
            ModalCard,
            VueEditor,
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/students/components/profile/About.vue